module.exports = __webpack_public_path__ + "img/faqseal_pic1.656c6ef5.png";